import { get, type Writable } from 'svelte/store';

/**
 * An action that can be used to auto-close tooltips or context-menus whenever the trigger leaves the viewport
 * @param node - the trigger HTML element node that should be observed (the node you're applying the action to)
 * @param store - the $open store of the UI-component
 */
export const closeOnLeaveAction = (node: Element, store: Writable<boolean>) => {
	let _store = store;

	const observer = new IntersectionObserver(
		([entry]) => {
			if (get(_store) && !entry.isIntersecting) {
				_store.set(false);
			}
		},
		{ threshold: 1 }
	);

	const handleChange = (isOpen: boolean) =>
		isOpen ? observer.observe(node) : observer.unobserve(node);
	let unsubscribe = store.subscribe(handleChange);

	const update = (store: Writable<boolean>) => {
		if (store !== _store) {
			unsubscribe();
			_store = store;
			unsubscribe = _store.subscribe(handleChange);
		}
	};

	return {
		update,
		destroy: () => {
			unsubscribe();
			observer.disconnect();
		}
	};
};
